import { Icon } from '@drdropin-tech/theseus';
import { ChangeEvent } from 'react';

type SearchBarProps = {
  placeholder: string;
  onChangeText: (e: ChangeEvent<HTMLInputElement>) => void;
};

export default function SearchBar({
  placeholder,
  onChangeText,
}: SearchBarProps) {
  return (
    <div className="relative flex w-full flex-row items-center">
      <div className="absolute pl-3">
        <Icon name="Search" iconSize="s" className="text-black" />
      </div>
      <input
        id="name"
        type="text"
        onChange={onChangeText}
        placeholder={placeholder}
        className="border-accent w-full rounded-lg border-2 p-2 pl-10 text-black"
      />
    </div>
  );
}
